import React from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Blog, EyeCare, OurDoctors, Testimonial } from "components";
import { Banner, OurFacility, WaveLightPlus } from "./components";
import { Helmet } from 'react-helmet-async';
import { department } from "./data";
import { useParams } from "react-router";

const EyeCareDetails = () => {
  const { departmentId } = useParams();

  const departmentData = department[departmentId];
  const {
    banner,
   // about,
    facility,  
    services,

    facility2,  
    facilityImg2,
    serviceHeader,
    bannerImg,
    // aboutImg,
    facilityImg,
    infoImg,
    info, 
    bannerSize,
    bestPediatricServices,
    faqsSection,
    title,
    description,
    keyword,
    Imageme,
    url,
  } = departmentData;

  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box>
      <Helmet>
            <title>{title}</title>
            <meta name="description" content={description || "Blog post detail page"} />
            <meta name="keywords" content={keyword}/>

            <meta name="title" content={title} />

            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description || "No Description"} />
            <meta property="og:image" content={Imageme} />


            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description || "No Description"} />
            <meta property="twitter:image" content={Imageme} />"


          </Helmet>
      <Banner
        banner={banner} 
        bannerImg={bannerImg}
        bannerSize={bannerSize || []}
      />

      <WaveLightPlus facility2={facility2} facilityImg2={facilityImg2} /> 
      {/* <About about={about} aboutImg={aboutImg} /> */}
      <OurFacility facility={facility} facilityImg={facilityImg} />

      

      {services?.length > 0 && (
        <EyeCare
          services={services}
          departmentId={departmentId}
          serviceHeader={serviceHeader}
        />
      )}
      
      <Box
        mb={-1.25}
        minHeight="43.75rem"
        sx={{
          background: `url(${infoImg}) no-repeat`,
          backgroundSize: "cover",
        }}
        display={"flex"}
        alignItems={"center"}
      >
        <Box
          width={{ md: "50%", xs: "100%" }}
          px={{ md: 8, xs: 5 }}
          lineHeight={1}
        >
          <Typography
            fontSize={{ md: "2.5rem", xs: "1.75rem" }}
            textTransform={"uppercase"}
          >
            {info?.heder}
          </Typography>
          <Typography
            fontSize={{ md: "3rem", xs: "2rem" }}
            fontWeight={"bold"}
            textTransform={"uppercase"}
          >
            {info?.subheader}
          </Typography>
          <Box width={{ md: "80%", xs: "100%" }} my={2}>
            <Box border={4} borderColor={"black"} textAlign={"center"}>
              <Box bgcolor="black" color="white" textAlign={"center"} py={0.5}>
                <Typography
                  fontSize={{ md: "2rem", xs: "1.75rem" }}
                  fontWeight={"bold"}
                  textTransform={"uppercase"}
                  textAlign={"center"}
                >
                  {info?.point1}
                </Typography>
              </Box>
              <Box textAlign={"center"} py={0.5}>
                <Typography
                  fontSize={{ md: "2rem", xs: "1.75rem" }}
                  fontWeight={"bold"}
                  textTransform={"uppercase"}
                  textAlign={"center"}
                >
                  {info?.point2}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      


      <OurDoctors filterKey={departmentId} departmentPage />
      <Testimonial />
      <Blog />
      {faqsSection && (
        <Box py={5}>
          <Typography
            fontSize={{ md: "2.5rem", xs: "2rem" }}
            fontWeight="bold"
            textAlign="center"
            component="h2"
          >
            {faqsSection.heading}
          </Typography>
          <Box mt={3} px={{ md: 8, xs: 3 }}>
            {faqsSection.services.map((service, idx) => {
              const panelId = `panel${idx + 1}`;
              const isExpanded = expanded === panelId;

              return (
                <Accordion
                  key={service.id || panelId}
                  expanded={isExpanded}
                  onChange={handleChange(panelId)}
                  elevation={0}
                  sx={{
                    boxShadow: "0 6px 18px rgba(19,22,24,0.04)",
                    borderRadius: "10px",
                    mb: 2.5,
                    "&:before": {
                      display: "none",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#2EAD9F" }} />}
                    aria-controls={`${panelId}-content`}
                    id={`${panelId}-header`}
                    sx={{
                      minHeight: 64,
                      "& .MuiAccordionSummary-content": {
                        margin: 0,
                        alignItems: "center",
                      },
                      px: { md: 4, xs: 3 },
                      py: { md: 1.5, xs: 1 },
                      ...(isExpanded && {
                        backgroundColor: "#BEEDE6",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }),
                    }}
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      {service.label}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      px: { md: 4, xs: 3 },
                      pt: 2.5,
                      pb: 3,
                      borderBottomLeftRadius: "10px",
                      borderBottomRightRadius: "10px",
                    }}
                  >
                    <Typography sx={{ color: "#5f6468", lineHeight: 1.8 }}>
                      {service.content}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default EyeCareDetails;
